var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-editor"},[_c('u-editor',{model:{value:(_vm.$$FormData.content),callback:function ($$v) {_vm.$set(_vm.$$FormData, "content", $$v)},expression:"$$FormData.content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }